import './style.scss';
import slick from 'slick-carousel';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';

let width = $(window).innerWidth;

function doctorSidebar() {
    let sidebar = $('.doctorList .container > .col-4');
    let footer = $('.elementor-location-footer');
    let offsetTop = sidebar.offset().top; // 初始位置
    let sidebarHeight = sidebar.outerHeight(true);
    let footerTop = footer.offset().top;
    let marginBottom = 20;

    $(window).scroll(function () {
        let scrollTop = $(window).scrollTop();
        let sidebarBottom = scrollTop + sidebarHeight + marginBottom;

        if (scrollTop <= offsetTop - marginBottom) {
            // 滾動回原始位置時，讓 sidebar 回到初始狀態
            sidebar.css({
                "position": "absolute",
                "top": "0px"
            });
        } else if (sidebarBottom >= footerTop) {
            // sidebar 底部碰到 footer
            sidebar.css({
                "position": "absolute",
                "top": (footerTop - sidebarHeight - marginBottom) + "px"
            });
        } else {
            // sidebar 固定在視窗內
            sidebar.css({
                "position": "fixed",
                "top": "0px"
            });
        }
    });
}
function smoothScroll() {
    $('.rsTeamsList a').on('click', function (e) {
        e.preventDefault();
        let targetId = $(this).attr('href');
        let targetOffset = $(targetId).offset().top - 20; // 讓標題有點距離
        $('html, body').animate({ scrollTop: targetOffset }, 500);
    });
}
function highlightActiveLink() {
    let links = $('.rsTeamsList a');
    let sections = $('.doctorItem');

    $(window).scroll(function () {
        let scrollTop = $(window).scrollTop();

        sections.each(function () {
            let sectionTop = $(this).offset().top - 50;
            let sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
                let id = $(this).attr('id');
                links.removeClass('active');
                $('.rsTeamsList a[href="#' + id + '"]').addClass('active');
            }
        });
    });
}

// home service slide
function homeServiceSlide() {
    $(".tabTitleItem").first().addClass("active"); // 預設第一個 tabTitleItem 為 active

    // 2️⃣ 初始化每個 hsItem 內的 Slick.js 輪播
    $(".hsItem").each(function () {
        var $thisItem = $(this);
        var $slider = $thisItem.find(".hsSlider"); // 找到當前 .hsItem 內的 .hsSlider
        var $counter = $thisItem.find(".sliderCounter"); // 找到當前 .hsItem 內的 .sliderCounter
        var $prevArrow = $thisItem.find(".prevSlide"); // 找到當前 .hsItem 內的上一頁按鈕
        var $nextArrow = $thisItem.find(".nextSlide"); // 找到當前 .hsItem 內的下一頁按鈕

        // 計算總頁數，預先載入
        var totalSlides = $slider.find(".hsContent").length;
        var formattedTotal = totalSlides.toString().padStart(2, "0");
        if ($counter.length) {
            $counter.text("01 / " + formattedTotal); // 預先顯示第一頁
        }

        // 初始化 Slick.js
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            dots: false,
        });

        // 更新頁碼
        function updateCounter(currentIndex, totalSlides) {
            var formattedIndex = (currentIndex + 1).toString().padStart(2, "0");
            var formattedTotal = totalSlides.toString().padStart(2, "0");
            if ($counter.length) {
                $counter.text(formattedIndex + " / " + formattedTotal);
            }
        }

        // Slick 初始化後，確保頁碼正確
        $slider.on("init", function (event, slick) {
            updateCounter(slick.currentSlide, slick.slideCount);
        });

        // 滑動後更新頁碼
        $slider.on("afterChange", function (event, slick, currentSlide) {
            updateCounter(currentSlide, slick.slideCount);
        });

        // 觸發 Slick 初始化
        $slider.slick("setPosition");
    });

    // 3️⃣ 點擊 tabTitleItem 切換 hsItem
    $(".tabTitleItem").on("click", function () {
        var index = $(this).data("index"); // 取得點擊的 data-index

        // 切換 tabTitleItem active 狀態
        $(".tabTitleItem").removeClass("active");
        $(this).addClass("active");

        // 切換 hsItem 顯示
        $(".hsSlide .hsItem").hide();
        $(".hsSlide .hsItem[data-index='" + index + "']").fadeIn();

        // 重新初始化 Slick.js，確保輪播正常
        var $slider = $(".hsSlide .hsItem[data-index='" + index + "']").find(".hsSlider");
        if ($slider.hasClass("slick-initialized")) {
            $slider.slick("refresh");
        } else {
            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                prevArrow: $(".hsSlide .hsItem[data-index='" + index + "']").find(".prevSlide"),
                nextArrow: $(".hsSlide .hsItem[data-index='" + index + "']").find(".nextSlide"),
                dots: false,
            });
        }
    });
}

function init() {
    homeServiceSlide()
    if (width > 768) {
        // doctorSidebar()
        // smoothScroll()
        // highlightActiveLink()
    }
}
window.onload = function () {
    init()
}
